// extracted by css-extract-rspack-plugin
export default {"header":"W7UTD","footer":"f3orJ","scrollable":"YdPvr"};